import React, { useEffect, useState } from "react";
import SignUpForm from "../../../components/Auth/SignUp/SignUpForm";
import Banner from "../../../components/Banner/Banner";
import { useLocation } from "react-router-dom";
import MainLayout from "../../../components/MainLayout/MainLayout";
import { useLanguage } from "../../../components/LanguageProvider/LanguageProvider ";
import { getHomePageContent } from "../../../services/api/outer";
import { ClearLocalStorage } from "../../../Utils/Utils";

const SignUp = () => {
  const { language, setLanguage } = useLanguage();
  const [homePageData, setHomePageData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchData = async () => {
      try {
        const [homePageDataResponse] = await Promise.all([
          getHomePageContent(),
        ]);
        setHomePageData(homePageDataResponse);
        setLoading(false);
      } catch (error) {
        //console.error("Error fetching data", error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    ClearLocalStorage();
  }, []);

  if (loading || homePageData === null) {
    return <></>;
  }
  return (
    <>
      <MainLayout homePageData={homePageData}>
        <Banner
          first={language ? "होम" : "Home"}
          
          second={language ? "रेजिस्ट्रेशन पृष्ठ" : "Registration Page"}
          head={language ? "रेजिस्ट्रेशन " : "Registration "}
        />
        {/* <div className="d-flex mt-4 mb-4 align-items-center justify-content-center p-4">
          <div
            className="d-flex align-items-start gap-3 p-4 rounded w-100"
            style={{
              backgroundColor: "#fcf3cf",
              maxWidth: "1200px",
              border: "1px solid #f5e6a8",
            }}
            role="alert"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="#e6a817"
              className="bi bi-exclamation-triangle-fill mt-4"
              viewBox="0 0 16 16"
              aria-hidden="true"
              style={{ lineHeight: 1, flexShrink: 0 }}
            >
              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
            </svg>

            <div>
              <h4 className="fw-bold mb-2" style={{ color: "#c9203a" }}>
                {language
                  ? "आवेदन जमा करने की प्रक्रिया अगली सूचना तक अस्थायी रूप से निलंबित है।"
                  : "Application Submission Temporarily Suspended Until Further Notice"}
              </h4>
              <p
                className="mb-0 mt-2"
                style={{ color: "#1f2937", lineHeight: "1.7" }}
              >
                {language
                  ? "नीति में चल रहे संशोधनों के कारण,"
                  : "Due to ongoing policy revisions, the"}{" "}
                <strong>
                  {language
                    ? "ट्रैवल ट्रेड सर्टिफिकेशन आवेदन प्रक्रिया"
                    : "Travel Trade Certification Application Process"}
                </strong>{" "}
                {language
                  ? "को अस्थायी रूप से निलंबित कर दिया गया है। अगली सूचना तक नए आवेदन स्वीकार नहीं किए जाएंगे। आवेदन प्रक्रिया के पुनः आरंभ होने से संबंधित अपडेट इस पोर्टल पर प्रकाशित किए जाएंगे।"
                  : "has been temporarily suspended. New applications will not be accepted until further notice. Updates regarding the reopening of the application process will be published on this portal."}
              </p>
            </div>
          </div>
        </div> */}
        <SignUpForm />
      </MainLayout>
    </>
  );
};
export default SignUp;
